{
  "name": "order-flow-3",
  "version": "3.2.1",
  "engines": {
    "node": ">=24.0.0"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/common": "^21.2.21",
    "@angular/compiler": "^21.2.21",
    "@angular/core": "^21.2.21",
    "@angular/forms": "^21.2.21",
    "@angular/platform-browser": "^21.2.21",
    "@angular/router": "^21.2.21",
    "@angular/service-worker": "^21.2.21",
    "@azure/msal-angular": "^5.3.1",
    "@azure/msal-browser": "^5.18.0",
    "@microsoft/signalr": "^10.0.11",
    "@rxweb/reactive-form-validators": "^13.0.1",
    "@syncfusion/ej2-angular-buttons": "^34.2.2",
    "@syncfusion/ej2-angular-calendars": "^34.2.2",
    "@syncfusion/ej2-angular-charts": "^34.2.3",
    "@syncfusion/ej2-angular-dropdowns": "^34.2.2",
    "@syncfusion/ej2-angular-grids": "^34.2.2",
    "@syncfusion/ej2-angular-inputs": "^34.2.2",
    "@syncfusion/ej2-angular-navigations": "^34.2.2",
    "@syncfusion/ej2-angular-notifications": "^34.2.2",
    "@syncfusion/ej2-angular-pdfviewer": "^34.2.2",
    "@syncfusion/ej2-angular-popups": "^34.2.2",
    "@syncfusion/ej2-angular-progressbar": "^34.2.2",
    "date-fns": "^4.4.0",
    "lodash-es": "~4.18.1",
    "ngx-indexed-db": "^22.0.0",
    "ngx-localstorage": "^6.0.0",
    "ngx-logger": "^5.0.12",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular/build": "^21.2.21",
    "@angular/cli": "^21.2.21",
    "@angular/compiler-cli": "^21.2.21",
    "@eslint/js": "^10.0.1",
    "@types/jasmine": "~6.0.0",
    "@types/lodash-es": "^4.17.12",
    "angular-eslint": "21.4.0",
    "baseline-browser-mapping": "^2.11.15",
    "eslint": "^10.8.1",
    "jasmine-core": "~7.0.2",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.3.0",
    "prettier": "^3.9.6",
    "typescript": "~6.0.3",
    "typescript-eslint": "8.67.0"
  }
}
